import { AppConfig } from './app';

export class UrlConfig {
  static AUTH = {
    LOGIN: `${AppConfig.API.CORE_URL}/auth/admin`,
    REGISTER: `${AppConfig.API.CORE_URL}/auth/register`,
    REFRESH: `${AppConfig.API.CORE_URL}/refresh`,
    EMAIL_AVAILABLE: `${AppConfig.API.CORE_URL}/email/available`,
    EMAIL_WHITELISTED: `${AppConfig.API.CORE_URL}/email/whitelisted`,
    USERNAME_AVAILABLE: `${AppConfig.API.CORE_URL}/username/available`,
  };

  static USER = {
    BASE: `${AppConfig.API.CORE_URL}/user`,
    FOLLOWING_ARTISTS: `${AppConfig.API.CORE_URL}/user/following/artists`,
    FOLLOWING_ARTISTS_ITEMS: `${AppConfig.API.CORE_URL}/user/following/artists/items`,
    FOLLOWING_ARTISTS_LISTINGS: `${AppConfig.API.CORE_URL}/user/following/artists/listings`,
    MIGRATE_IMAGE: `${AppConfig.API.CORE_URL}/user/migrate-image`,
    CHANGE_PASSWORD: `${AppConfig.API.CORE_URL}/user/change-password`,
    PORTFOLIO: `${AppConfig.API.CORE_URL}/user/portfolio`,
    WISHLIST: `${AppConfig.API.CORE_URL}/user/wishlist`,
    ACTIVE_MARKET: `${AppConfig.API.CORE_URL}/user/active-market`,
    CONFIRM: `${AppConfig.API.CORE_URL}/user/confirm`,
    CHANGE_FORGOTTEN_PASSWORD: `${AppConfig.API.CORE_URL}/user/change-forgotten-password`,
    ADD_PRIMARY_ADDRESS: `${AppConfig.API.CORE_URL}/user/add/primary-address`,
    USERS: `${AppConfig.API.CORE_URL}/admin/users`,
    ADMIN_USERS: `${AppConfig.API.CORE_URL}/users/admins`,
    ADMIN_USER_BY_ID: `${AppConfig.API.CORE_URL}/admin/user/`,
  };

  static ITEM = {
    BASE: `${AppConfig.API.CORE_URL}/item`,
    ITEM_BY_ID: `${AppConfig.API.CORE_URL}/item/`,
    ITEM_BY_ARTIST: `${AppConfig.API.CORE_URL}/item/artist/`,
    ITEM_SEARCH: `${AppConfig.API.CORE_URL}/item/search`,
    ITEM_ALL: `${AppConfig.API.CORE_URL}/item/all`,
    ITEM_BID:`${AppConfig.API.CORE_URL}/item/bid/`,
    ITEM_ASK: `${AppConfig.API.CORE_URL}/item/ask/`,
    ITEM_PLACE_BID: `${AppConfig.API.CORE_URL}/item/bid/create`,
    ITEM_PLACE_ASK: `${AppConfig.API.CORE_URL}/item/ask/create`,
    ITEM_PLACE_INQUIRY: `${AppConfig.API.CORE_URL}/item/inquiry/create`,
    ITEM_ASK_MARK_EXPIRE: `${AppConfig.API.CORE_URL}/item/ask/mark/expire`,
    ITEM_BID_MARK_EXPIRE: `${AppConfig.API.CORE_URL}/item/bid/mark/expire`,
    ITEM_UPDATE: `${AppConfig.API.CORE_URL}/item/`,
    ITEM_DEMOTE: `${AppConfig.API.CORE_URL}/item/demote`,
    ITEM_PROMOTE: `${AppConfig.API.CORE_URL}/item/promote`,
    ITEM_CREATE_FROM_LISTING: `${AppConfig.API.CORE_URL}/item/create-from-listing/`,
    ITEM_MARKET_REFRESH: `${AppConfig.API.CORE_URL}/item/market/refresh`,
    ITEM_ENHANCE: `${AppConfig.API.CORE_URL}/item/enhance`,
    ITEM_REMOVE_BACKGROUND: `${AppConfig.API.CORE_URL}/item/image/remove-background`,
    ITEM_MIGRATE_IMAGE: `${AppConfig.API.CORE_URL}/item/migrate-image`
  };

  static EXCHANGE_RATE = {
    LATEST: `${AppConfig.API.CORE_URL}/exchange-rate/latest`
  };

  static DEMOTED_ITEM = {
    BASE: `${AppConfig.API.CORE_URL}/demoteditem`,
    ITEM_BY_ID: `${AppConfig.API.CORE_URL}/demoteditem/`,
    ITEM_SEARCH: `${AppConfig.API.CORE_URL}/demoteditem/search`
  };

  static ITEM_DATA_SUGGESTION = {
    BASE: `${AppConfig.API.CORE_URL}/item-data-suggestion`,
    ITEM_DATA_SUGGESTION_CREATE: `${AppConfig.API.CORE_URL}/item-data-suggestion/create`,
    ITEM_DATA_SUGGESTION_DETAILED_STATUS: `${AppConfig.API.CORE_URL}/item-data-suggestion/detailed/status/`,
    ITEM_DATA_SUGGESTION_APPROVE: `${AppConfig.API.CORE_URL}/item-data-suggestion/approve`,
    ITEM_DATA_SUGGESTION_REJECT: `${AppConfig.API.CORE_URL}/item-data-suggestion/reject`
  }

  static ITEM_SALE_SUGGESTION = {
    BASE: `${AppConfig.API.CORE_URL}/item-sale-suggestion`,
    ITEM_SALE_SUGGESTION_CREATE: `${AppConfig.API.CORE_URL}/item-sale-suggestion/create`
  }

  static LISTING_DATA_SUGGESTION = {
    BASE: `${AppConfig.API.CORE_URL}/listing-data-suggestion`,
    LISTING_DATA_SUGGESTION_CREATE: `${AppConfig.API.CORE_URL}/listing-data-suggestion/create`,
    LISTING_DATA_SUGGESTION_DETAILED_STATUS: `${AppConfig.API.CORE_URL}/listing-data-suggestion/detailed/status/`,
    LISTING_DATA_SUGGESTION_APPROVE: `${AppConfig.API.CORE_URL}/listing-data-suggestion/approve`,
    LISTING_DATA_SUGGESTION_REJECT: `${AppConfig.API.CORE_URL}/listing-data-suggestion/reject`
  }

  static LISTING = {
    BASE: `${AppConfig.API.CORE_URL}/listing`,
    LISTING_BY_ID: `${AppConfig.API.CORE_URL}/listing/`,
    LISTING_SEARCH: `${AppConfig.API.CORE_URL}/listing/search`,
    LISTING_MARK_FAKE: `${AppConfig.API.CORE_URL}/listing/mark/fake`,
    LISTING_MARK_SET: `${AppConfig.API.CORE_URL}/listing/mark/set`,
    LISTING_MARK_ORIGINAL: `${AppConfig.API.CORE_URL}/listing/mark/original`,
    LISTING_REJECT: `${AppConfig.API.CORE_URL}/listing/reject`,
    LISTING_MIGRATE_IMAGE: `${AppConfig.API.CORE_URL}/listing/migrate-image`
  };

  static LISTING_SUGGESTION = {
    LISTING_SUGGESTED_ITEMS: (listingId: string) => `${AppConfig.API.INTELLIGENCE_URL}/listings/${listingId}/suggested-items`
  }

  static ITEM_SUGGESTION = {
    ITEM_SUGGESTED_LISTINGS: (itemId: string) => `${AppConfig.API.INTELLIGENCE_URL}/items/${itemId}/suggested-listings`,
    RECOMPUTE_ITEM_SUGGESTIONS: (itemId: string) => `${AppConfig.API.INTELLIGENCE_URL}/ops/recompute-item-suggestions/${itemId}`
  }

  static DEDUP_INTELLIGENCE = {
    DEDUP_ITEMS_ALL: `${AppConfig.API.INTELLIGENCE_URL}/dedup-items/all`,
    DEDUP_ITEMS_BY_ARTIST: (artistId: string) => `${AppConfig.API.INTELLIGENCE_URL}/dedup-items/artist/${artistId}`,
    DEDUP_ITEM_DELETE: (itemId: string) => `${AppConfig.API.INTELLIGENCE_URL}/dedup-items/item/${itemId}`,
    DEDUP_ITEM_PAIR_DELETE: (primaryItemId: string, secondaryItemId: string) => `${AppConfig.API.INTELLIGENCE_URL}/dedup-items/${primaryItemId}/${secondaryItemId}`,
  }

  static DEMOTED_LISTING = {
    BASE: `${AppConfig.API.CORE_URL}/demoted-listing`,
    LISTING_BY_ID: `${AppConfig.API.CORE_URL}/demoted-listing/`,
    LISTING_SEARCH: `${AppConfig.API.CORE_URL}/demoted-listing/search`,
    LISTING_MIGRATE_IMAGE: `${AppConfig.API.CORE_URL}/demoted-listing/migrate-image`
  };

  static PORTFOLIO = {
    BASE: `${AppConfig.API.CORE_URL}/portfolio`,
    PORTFOLIO_BY_ID: `${AppConfig.API.CORE_URL}/portfolio/`,
    PORTFOLIO_HISTORY: `${AppConfig.API.CORE_URL}/portfolio/history/`,
    PORTFOLIO_ADD_ITEM: `${AppConfig.API.CORE_URL}/portfolio/add_item`,
    PORTFOLIO_REMOVE_ITEM: `${AppConfig.API.CORE_URL}/portfolio/remove_item`,
    PORTFOLIO_REPLACE_ITEM: `${AppConfig.API.CORE_URL}/portfolio/replace_item`
  };

  static WISHLIST = {
    BASE: `${AppConfig.API.CORE_URL}/wishlist`,
    WISHLIST_BY_ID: `${AppConfig.API.CORE_URL}/wishlist/`,
    WISHLIST_ADD_ITEM: `${AppConfig.API.CORE_URL}/wishlist/add_item`,
    WISHLIST_REMOVE_ITEM: `${AppConfig.API.CORE_URL}/wishlist/remove_item`
  };

  static ARTIST = {
    BASE: `${AppConfig.API.CORE_URL}/artist`,
    ARTIST_BY_ID: `${AppConfig.API.CORE_URL}/artist/`,
    ARTIST_BY_ITEM: `${AppConfig.API.CORE_URL}/artist/item/`,
    ARTIST_ALL: `${AppConfig.API.CORE_URL}/artist/all`,
    ARTIST_ENABLED: `${AppConfig.API.CORE_URL}/artist/enabled`,
    ARTIST_FOLLOW: `${AppConfig.API.CORE_URL}/user/follow/artist`,
    ARTIST_UNFOLLOW: `${AppConfig.API.CORE_URL}/user/unfollow/artist`,
    ARTIST_UPDATE: `${AppConfig.API.CORE_URL}/artist/`,
    ARTIST_CREATE: `${AppConfig.API.CORE_URL}/artist/create`,
    INDEX_REGENERATE: `${AppConfig.API.CORE_URL}/artist/index/regenerate`,
    INDEX_REFRESH: `${AppConfig.API.CORE_URL}/artist/index/refresh`,
    ARTIST_MIGRATE_IMAGE: `${AppConfig.API.CORE_URL}/artist/migrate-image`
  }

  static COMPOSITE_INDEX = {
    BASE: `${AppConfig.API.CORE_URL}/composite/index`,
    EDITION: `${AppConfig.API.CORE_URL}/composite/index/EDITION_INDEX`,
    INDEX_REFRESH: `${AppConfig.API.CORE_URL}/composite/index/refresh`,
    INDEX_REGENERATE: `${AppConfig.API.CORE_URL}/composite/index/regenerate`,
  }

  static DEDUP_ITEM = {
    BASE: `${AppConfig.API.CORE_URL}/dedup_item`,
    DEDUP_ITEM_BY_ID: `${AppConfig.API.CORE_URL}/dedup_item/`,
    DEDUP_ITEM_ALL: `${AppConfig.API.CORE_URL}/dedup_item/all`,
    DEDUP_ITEM_APPROVE: `${AppConfig.API.CORE_URL}/dedup_item/approve`,
    DEDUP_ITEM_REJECT: `${AppConfig.API.CORE_URL}/dedup_item/reject`,
  }

  static DEDUP_LISTING = {
    BASE: `${AppConfig.API.CORE_URL}/dedup_listing`,
    DEDUP_LISTING_BY_ID: `${AppConfig.API.CORE_URL}/dedup_listing/`,
    DEDUP_LISTING_ALL: `${AppConfig.API.CORE_URL}/dedup_listing/all`,
    DEDUP_LISTING_APPROVE: `${AppConfig.API.CORE_URL}/dedup_listing/approve`,
    DEDUP_LISTING_REJECT: `${AppConfig.API.CORE_URL}/dedup_listing/reject`,
  }

  static UPLOAD = {
    BASE: `${AppConfig.API.CORE_URL}/upload`,
    IMAGE: `${AppConfig.API.CORE_URL}/upload/image`,
    FILEPOD_IMAGE: `${AppConfig.API.CORE_URL}/upload/fp/image`,
    FILEPOD_IMAGE_DELETE: `${AppConfig.API.CORE_URL}/upload/fp/image/delete`,
  }

  static MAIL = {
    BASE: `${AppConfig.API.CORE_URL}/mail`,
    SEND_USER_CONFIRMATION: `${AppConfig.API.CORE_URL}/mail/user/send-confirmation-email`,
    SEND_USER_FORGOT_PASSWORD: `${AppConfig.API.CORE_URL}/mail/user/send-forgot-password-email`,
    SEND_INBOUND_CONTACT_REQUEST: `${AppConfig.API.CORE_URL}/mail/inbound/contact-request`
  }

  static MATERIAL = {
    BASE: `${AppConfig.API.CORE_URL}/material`,
    MATERIAL_BY_ID: `${AppConfig.API.CORE_URL}/material/`,
    MATERIAL_ALL: `${AppConfig.API.CORE_URL}/material/all`,
  }

  static SALES_VENUE = {
    BASE: `${AppConfig.API.CORE_URL}/salesvenue`,
    SALES_VENUE_BY_ID: `${AppConfig.API.CORE_URL}/salesvenue/`,
    SALES_VENUE_ALL: `${AppConfig.API.CORE_URL}/salesvenue/all`,
  }

  static ITEM_LISTING_GROUPING = {
    BASE: `${AppConfig.API.CORE_URL}/grouping`
  }

  static WAITLIST = {
    BASE: `${AppConfig.API.CORE_URL}/user-waitlist`,
    CREATE: `${AppConfig.API.CORE_URL}/user-waitlist/create`,
    STATUS: `${AppConfig.API.CORE_URL}/user-waitlist/status/`,
    APPROVE: `${AppConfig.API.CORE_URL}/user-waitlist/approve`,
    REJECT: `${AppConfig.API.CORE_URL}/user-waitlist/reject`
  }

  static CONTENT = {
    HOME_FEED: `${AppConfig.API.CORE_URL}/content/home/feed`
  }

  static ACTIVE_MARKET = {
    BASE: `${AppConfig.API.CORE_URL}/active-market`,
    ACTIVE_MARKET_ALL: `${AppConfig.API.CORE_URL}/active-market/all`
  }

  static MARKETPLACE = {
    BASE: `${AppConfig.API.CORE_URL}/marketplace`,
    USER_ACTIVATE_SELLING: `${AppConfig.API.CORE_URL}/marketplace/user/activate/selling`,
    USER_ONBOARD_SELLING: `${AppConfig.API.CORE_URL}/marketplace/user/onboard/selling`,
    USER_ORDERS: `${AppConfig.API.CORE_URL}/marketplace/user/orders`,
    USER_DASHBOARD_LINK: `${AppConfig.API.CORE_URL}/marketplace/user/dashboard/link`,
    ITEM_ASK_CREATE_PAYMENTLINK: `${AppConfig.API.CORE_URL}/marketplace/item/ask/create/paymentlink`,
    ITEM_BID_ACCEPT: `${AppConfig.API.CORE_URL}/marketplace/item/bid/accept`,
    ORDER: `${AppConfig.API.CORE_URL}/marketplace/order`,
    ORDER_ADD_ADDRESS: `${AppConfig.API.CORE_URL}/marketplace/order/add-address`,
  }

  static GROUPING = {
    BASE: `${AppConfig.API.CORE_URL}/grouping`,
    GROUPING_BY_ID: `${AppConfig.API.CORE_URL}/grouping/`,
    GROUPING_BY_STATUS: `${AppConfig.API.CORE_URL}/grouping/status/`,
    GROUPING_DETAILED_STATUS: `${AppConfig.API.CORE_URL}/grouping/detailed/status/`,
    GROUPING_SEARCH: `${AppConfig.API.CORE_URL}/grouping/search`,
    GROUPING_APPROVE: `${AppConfig.API.CORE_URL}/grouping/approve`,
    GROUPING_REJECT: `${AppConfig.API.CORE_URL}/grouping/reject`,
    GROUPING_PROCESS: `${AppConfig.API.CORE_URL}/grouping/process`,
    GROUPING_ALL: `${AppConfig.API.CORE_URL}/grouping/all`,
  }

  static SCRAPEJOB = {
    BASE: `${AppConfig.API.CORE_URL}/scrapejob`,
    SCRAPEJOB_BY_ID: `${AppConfig.API.CORE_URL}/scrapejob/`,
    SCRAPEJOB_BY_STATUS: `${AppConfig.API.CORE_URL}/scrapejob/status/`,
    SCRAPEJOB_DETAILED_STATUS: `${AppConfig.API.CORE_URL}/scrapejob/detailed/status/`,
    SCRAPEJOB_ALL: `${AppConfig.API.CORE_URL}/scrapejob/all`,
    SCRAPEJOB_APPROVE: `${AppConfig.API.CORE_URL}/scrapejob/approve`,
    SCRAPEJOB_REJECT: `${AppConfig.API.CORE_URL}/scrapejob/reject`,
    SCRAPEJOB_SANITIZE: `${AppConfig.API.CORE_URL}/scrapejob/sanitize`,
  }

  static SCRAPESITE = {
    BASE: `${AppConfig.API.CORE_URL}/scrapesite`,
    SCRAPESITE_ALL: `${AppConfig.API.CORE_URL}/scrapesite/all`,
  }

  static MERGE = {
    BASE: `${AppConfig.API.CORE_URL}/merge`,
    MERGE_BY_ID: `${AppConfig.API.CORE_URL}/merge/`,
    MERGE_ALL: `${AppConfig.API.CORE_URL}/merge/all`,
    MERGE_BY_STATUS: `${AppConfig.API.CORE_URL}/merge/status/`,
    MERGE_DETAILED_STATUS: `${AppConfig.API.CORE_URL}/merge/detailed/status/`,
    MERGE_CREATE: `${AppConfig.API.CORE_URL}/merge/item`,
    MERGE_APPROVE: `${AppConfig.API.CORE_URL}/merge/approve`,
    MERGE_REJECT: `${AppConfig.API.CORE_URL}/merge/reject`,
  }
}
